import Link from "next/link";
import ProfileBtn from "../common/v2-profile-btn";
import Logo from "../icon/v2-logo";

const v2UrlPrefix = process.env.NEXT_PUBLIC_V2_URL_PREFIX;

const AgreeHeader = () => {
  return (
    <nav className="fixed top-0 left-0 z-20 items-center transition-all duration-300 bg-white w-full h-[54px] lg:h-[70px] sm:px-[64px] shadow-sm px-[20px]">
      <div className="relative flex items-center justify-between h-full">
        <Link href={`${v2UrlPrefix}`} className="w-[100px] md:w-[118px]">
          <Logo type="long" />
        </Link>

        <ProfileBtn />
      </div>
    </nav>
  );
};

export default AgreeHeader;
